<template>
    <div class="container mt-l lg:mt-l lg:pt-l">
        <div class="text-center">
            <span v-if="loadingArticles"><i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i></span>
        </div>

        <div v-if="articles.length > 0 && !loadingArticles">
            <h1 class="text-32 font-bold text-onyx leading-1-19">
                Search Results for “<span>{{ searchtext }}</span>” ( <span>{{ resultCount }}</span> )
            </h1>

            <div>
                <div class="mt-xl md:mt-l lg:mt-xxl-2">
                    <div class="grid grid-cols-1 row-gap-xxl-2 md:grid-cols-2 lg:grid-cols-3 md:col-gap-xl md:row-gap-xxl-2">
                        <div class="" v-for="article in articles">
                            <blog-header
                                    :article="article"
                                    :urlBlogShow="urlBlogShow"
                                    :urlBlogCategory="urlBlogCategory"
                                    img-height="md:h-228px"
                            ></blog-header>
                        </div>
                    </div>
                </div>

                <div class="text-center mt-xxl-2" v-show="moreExists">
                    <primary-button @click="loadMoreArticles" size="large" class="w-115px h-48px sm:w-auto sm:h-auto" title="See More">
                        <span>See More</span>
                        <span v-if="loadingMoreArticles"><i class="fa fa-spinner fa-pulse fa-fw"></i></span>
                    </primary-button>
                </div>
            </div>
        </div>

        <div v-if="articles.length === 0 && !loadingArticles">
            <h1 class="text-16 font-bold text-onyx leading-1-19">No results for “{{ searchtext }}”</h1>

            <div class="mt-xl md:mt-l lg:mt-xxl-2" v-if="popularArticles.length > 0">
                <h1 class="text-32 font-bold text-onyx line-1-19 sm:leading-1-19">
                    Popular Articles
                </h1>

                <div class="mt-xl">
                    <div class="grid grid-cols-1 row-gap-xxl-2 md:grid-cols-2 lg:grid-cols-3 md:col-gap-xl md:row-gap-xxl-2">
                        <div class="" v-for="article in randomisePopularArticles">
                            <blog-header
                                    :article="article"
                                    :urlBlogShow="urlBlogShow"
                                    :urlBlogCategory="urlBlogCategory"
                                    img-height="md:h-228px"
                            ></blog-header>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import BlogHeader from "./BlogHeader";

    export default {
        name: "BlogSearchResults",

        props: {
            searchtext: {
                type: String,
                default: ''
            },
            urlBlogShow: {
                type: String,
                required: true
            },
            urlBlogCategory: {
                type: String,
                required: true
            },
        },

        components: { BlogHeader },

        data() {
            return {
                articles: [],
                popularArticles: [],
                resultCount: null,
                moreExists: false,
                loadingMoreArticles: false,
                loadingArticles: false,
                nextPage: 0
            }
        },

        computed: {
            randomisePopularArticles: {
                get() {
                    return this.popularArticles.sort(() => .5 - Math.random()).slice(0,6)
                }
            }
        },

        methods: {
            loadArticles: async function() {
                this.loadingArticles = true;
                let response = await axios.get(`/api/blogs/${this.searchtext}`);
                this.articles = response.data.data
                this.resultCount = response.data.total
                this.loadingArticles = false;
                if (this.resultCount === 0) {
                    await this.loadPopularArticles();
                }
                this.toggleBtnDisplay(response.data);
            },

            loadMoreArticles: async function() {
                this.loadingMoreArticles = true;
                let response = await axios.get(`/api/blogs/${this.searchtext}?page=${this.nextPage}`);
                this.toggleBtnDisplay(response.data)
                this.loadingMoreArticles = false;

                response.data.data.forEach(data => {
                    this.articles.push(data)
                })
            },

            loadPopularArticles: async function() {
                this.loadingArticles = true;
                let response = await axios.get(`/api/blogs/popular`);
                this.popularArticles = response.data;
                this.loadingArticles = false;
            },

            toggleBtnDisplay(data){
                if (data.current_page < data.last_page) {
                    this.moreExists = true
                    this.nextPage = data.current_page + 1;
                }else {
                    this.moreExists = false
                }
            }
        },

        mounted() {
            this.loadArticles();
        },
    }
</script>
